"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _StepGroup = _interopRequireDefault(require("./StepGroup"));

/* eslint react/no-did-mount-set-state: 0 */
var Steps = function Steps(props) {
  var _stepIndex = (0, _react.useRef)(0);
  var setNumberChange = (0, _react.useCallback)(function (index) {
    _stepIndex.current = index;
  }, []);
  var getNumberChange = (0, _react.useCallback)(function () {
    return _stepIndex.current;
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_StepGroup["default"], (0, _extends2["default"])({}, props, {
    setNumberChange: setNumberChange,
    getNumberChange: getNumberChange
  }));
};
Steps.displayName = 'RcSteps';
var _default = Steps;
exports["default"] = _default;